import ES from './ES.json';
import EN from './EN.json';
import DE from './DE.json';

const dictionary = { ES, EN, DE };

export default dictionary;